import React, {useEffect} from 'react'
import {Button, Stack} from 'react-bootstrap';
import {Formik} from 'formik';
import {formatDateToDDMMYYYY} from '../../../../../../utils/FormatUtils';
import {CODE, RESPONSE_MESSAGE} from '../../../../../../utils/Constant';
import {toast} from 'react-toastify';
import moment from 'moment';
import {usePhanHeKhamBenhContext} from "../../../../../contexts/PhanHeTiepDonContext";
import {getThongTinNghiOm, inGiayNghiOm, saveThongTinNghiOm} from "../../../../../services/PrintExportService";
import PhieuLayout from "../../../shared/PhieuLayout";
import ButtonIn from "../../../../../../component/button-in-phieu";
import GiayNghiOmForm from "./components/GiayNghiOmForm";

const GiayNghiOm = () => {
  const {benhNhanInfo} = usePhanHeKhamBenhContext();
  const formikRef = React.useRef<any>();

  const handleSubmitForm = async (values: any) => {
    try {
      let submitData = {
        slDiagnosisAndTreatmentMethod: values?.slDiagnosisAndTreatmentMethod,
        slNumberOfLeaveDays: values?.slNumberOfLeaveDays,
        slStartDate: formatDateToDDMMYYYY(values?.slStartDate),
        slEndDate: formatDateToDDMMYYYY(values?.slEndDate),
        slDoctorName: values?.slDoctorName,
        slDepartmentHead: values?.slDepartmentHead,
        slRepresentative: values?.slRepresentative,
        slInsCode: values?.slInsCode,
        slSocialInsCode: values?.slSocialInsCode,
        slWorkplace: values?.slWorkplace,
        slFatherName: values?.slFatherName,
        slMotherName: values?.slMotherName,
        slPregnancyTermination: values?.slPregnancyTermination,
        slGestationalAge: values?.slGestationalAge,
        slPregnancyTerminationReason: values?.slPregnancyTerminationReason,
        slNotes: values?.slNotes,
      };
      let {data} = await saveThongTinNghiOm(benhNhanInfo?.thongTinKhamBenh?.visitId, submitData);
      if (CODE.SUCCESS === data?.code) {
        toast.success("Lưu thành công");
      } else {
        toast.warning(RESPONSE_MESSAGE.ERROR);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetThongTinNghiOm = async () => {
    try {
      let {data} = await getThongTinNghiOm(benhNhanInfo?.thongTinKhamBenh?.visitId);
      if (CODE.SUCCESS === data?.code) {
        formikRef?.current?.setValues({
          ...data?.data,
          slStartDate: moment(data?.data?.slStartDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
          slEndDate: moment(data?.data?.slEndDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
        });
      } else {
        toast.warning(RESPONSE_MESSAGE.ERROR);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    handleGetThongTinNghiOm();
  }, []);

  return (
    <PhieuLayout>
      <PhieuLayout.Main>
        <Formik<any>
          initialValues={{}}
          onSubmit={(values: any) => handleSubmitForm(values)}
          innerRef={formikRef}
        >
          {({submitForm}) => (
            <PhieuLayout.Content>
              <PhieuLayout.Form>
                <GiayNghiOmForm />
              </PhieuLayout.Form>
              <PhieuLayout.Action>
                <Stack
                  direction="horizontal"
                  className="spaces gap-8 w-100 justify-content-end"
                >
                  <ButtonIn
                    fetchExport={inGiayNghiOm}
                    params={{
                      orderId: benhNhanInfo?.thongTinKhamBenh?.orderId,
                    }}
                  />
                  <Button
                    className="btn-fill spaces min-w-80"
                    type="submit"
                    onClick={() => {
                      submitForm();
                    }}
                  >
                    Lưu
                  </Button>
                </Stack>
              </PhieuLayout.Action>
            </PhieuLayout.Content>
          )}
        </Formik>
      </PhieuLayout.Main>
    </PhieuLayout>
  );
};

export default GiayNghiOm